// Balance thresholds — «چقدر اعتبار کم است؟» answered once.
//
// THE DEFINITION MOVED. It lives in `@parsina/framework/tokens` as of framework
// v0.10.0 and this file is now a re-export, so the call sites that know it by
// this path keep working while there is exactly ONE copy in the monorepo.
//
// The old comment here said these numbers were "deliberately identical" to the
// doctor client's — and the doctor client's said the same about this one, and the
// clinic client carried a third copy. Three files kept in sync by comment is not
// a mechanism. One person has ONE wallet, and there is deliberately no `dentist`
// owner_type: a top-up made in this panel pays for an AI call made in the doctor
// panel, so «اعتبار کم» must mean the same thing in both.
//
// Still true, and still worth saying: this is a CLIENT rule about how a balance
// is PAINTED. It is not the wallet's alert threshold — that one is configurable
// per account and lives on the server (`myLowBalanceConfig`); this is the red
// floor below which the page puts a top-up button in front of the dentist
// regardless.
//
// Add nothing to this file. A new rule belongs in the framework.
export {
  CREDIT_LOW,
  CREDIT_MID,
  creditLevel,
  CREDIT_LEVEL_META,
  creditColor,
} from '@parsina/framework/tokens';
